import React from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BorderedButton, GradientBorderBox } from "../../../../Components";
import { blogNavigatePath } from "../../../../Utils/detailsNavigatePath";

export default function BlogPageCart({ title, des, img, url, seo , data}) {
  const navigate = useNavigate();
  const theme = useTheme();

  // استایل‌های ثابت خارج از JSX
  const imageSx = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px",
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", md: "250px", lg: "330px", xxl: "390px" },
        minHeight: { xs: "auto", md: "350px", lg: "420px", xxl: "490px" },
        display: "flex",
        flexDirection: { xs: "row", md: "column" },
        position: "relative",
        bgcolor: theme.palette.background.lightBlue,
        borderRadius: "6px",
        gap: 1,
        p: { xs: "12px", sm: "16px" },
        cursor: "pointer",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: theme.shadows[4],
        },
      }}
      onClick={() => navigate(blogNavigatePath(data))}
    >
      {/* بخش تصویر */}
      <Box
        sx={{
          flex: { xs: "0 0 40%", md: "unset" },
          aspectRatio: "1/1",
          height: {
            xs: "120px",
            md: "190px",
            lg: "250px",
            xl: "260px",
          },
        }}
      >
        <img
          style={imageSx}
          src={`${import.meta.env.VITE_URL}${img?.file_name}`}
          alt={img?.alt || title}
          loading="lazy"
        />
      </Box>

      {/* بخش محتوا */}
      <Stack
        sx={{
          flex: 1,
          justifyContent: "space-between",
          mt: { xs: 0, md: "1rem" },
          overflow: "hidden",
        }}
      >
        <Typography
          sx={{
            direction: "rtl",
            my: "10px",
            fontSize: { xs: ".9rem", xl: "1.1rem" },
            color: theme.palette.text.main,
            opacity: ".7",
            fontWeight: "500",
            lineHeight: 1.4,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            width: "100%",
          }}
        >
          {title || ""}
        </Typography>

        <BorderedButton
          variant="contained"
          sx={{
            my: "10px",
            mx: { xs: 0, md: "20px" },
            fontWeight: "bold",
            borderRadius: "6px",
            alignSelf: { xs: "flex-start", md: "center" },
            fontSize: { xs: ".7rem", lg: ".9rem" },
            zIndex: 10,
          }}
        >
          مشاهده متن کامل
        </BorderedButton>
      </Stack>

      {/* افکت دکوراتیو */}
      <GradientBorderBox
        inside
        bg={false}
        bgGrad="linear-gradient(
               135deg,
               rgb(157, 157, 157) -30%,
               #31313130 50%,
                #2f2f2f 100%
             )"
      />
    </Box>
  );
}
